/**
 * @requires ./frc.js
 * @requires ./frc.utilities.js
 * @requires ./frc.api.js
 */

frc.pages.locations = {
 	"config": {
 		"maxDistanceMiles": 50
 	},
 	"data": {
 		"displayState": "initial",
 		"view": "list",
 		"listings": null,
 		"biasing": {
 			"type": null,
 			"value": {
 				"raw": null,
 				"coords": null,
 				"geocoded": null
 			},
 			"method": null
 		},
 		"viewAllLink": "./",
 		"mapInited": false,
 		"listInited": false,
 		"geocodePerformed": false
 	},
 	"init": function(){

 		var self = frc.pages.locations;
 		frc.page = self;

 		var geoSearchCombo = new frc.modules.geoSearchCombo($(".find-location.location-search form"));
 		geoSearchCombo.data.submitFunction = function(submitContext){
 			var params = {};
 			if(submitContext=="geolocation"){
 				params.coords = frc.data.user.geolocation.coordinates.join(",");
 			} else {
 				params.query = geoSearchCombo.data.$queryField.val();
 			}
			if(self.data.view!="list"){
				params.view = self.data.view;
			}
			window.location.href = "./?" + $.param(params);
 		}

 		$(self).on('dataready', function(){
 			self.populateResultsMessage();

 			switch(self.data.view){
 				case "map":
 					self.renderMap();
 				break;
 				case "list":
 					if(self.data.displayState=="biased"){
 						self.populateBiasedView(self.data.listings);
 					}
 				break;
 			}
 		});

 		self.pinNavigation();

 		$(self).on('geocodecomplete', function(){
			if(!self.data.listings){
				self.getData();
			}
 		});

 		$(window).on('maptilesloaded', function(){
 			$(".locations-map").addClass("tilesloaded");
 			if (frc.page.data.mapMarkers && frc.page.data.mapMarkers.length) {
 				if (self.data.biasing.method == "query" || self.data.biasing.method == "geo") {
 					self.selectMarker(frc.page.data.mapMarkers[0]);
 				}
 				else {
 					if (frc.data.user.nearestLocation) {
 						for (var i = 0; i < frc.page.data.mapMarkers.length; i++) {
 							var markerInfo = frc.page.data.mapMarkers[i];
 							if (markerInfo.listing.location.id == frc.data.user.nearestLocation.id) {
 								self.selectMarker(markerInfo);
 								break;
 							}
 						}
 					}
 				}
 			}
 		});

 		$(self).on('viewchanged', function(){
			switch(self.data.view) {
				case 'map':
					$('.fl_list').removeClass('active');
					$('.fl_map').addClass('active');
				break;

				default:
					$('.fl_list').addClass('active');
					$('.fl_map').removeClass('active');
			}

			if (self.data.geocodePerformed) {
				self.populateResultsMessage();
			}

			// console.log(self.data);

			// Geographically biasing. Get coordinates (either by geolocation or geocoding) if needed.
			if(self.data.biasing.type=="geographic" && !self.data.biasing.value.coords){
				if(self.data.biasing.method=="query"){
					if(!self.data.geocodePerformed){
						self.data.geocodePerformed = true;
						frc.api.core.geocode(self.data.biasing.value.raw, function(result){
							if(result.data){
								self.data.biasing.value.geocoded = result.data;
								if(result.data.latitude && result.data.longitude){
									self.data.biasing.value.coords = [result.data.latitude, result.data.longitude];
									$(self).trigger('geocodecomplete', self.data.biasing.value.coords);
								}
							}
							else {
								self.populateResultsMessage();
							}
						});
					}
				}
				return;
			}

			if(self.data.displayState=="initial" && self.data.view=="list") {
				$(window).trigger('listing-loaded');
			} else {
				if(!self.data.listings){
					// Get data if needed
					self.getData();
				} else {

					// Render UI if have data
					if(self.data.view=="map" && !self.data.mapInited){
						self.renderMap();
						self.populateBiasedView(self.data.listings);
					}
					if(self.data.view=="list" && !self.data.listInited){
						self.data.listInited = true;
						self.populateBiasedView(self.data.listings);
					}
				}
			}

 		});

 		$(window).on("popstate", function(e){
 			e = e.originalEvent;
 			if(e && e.state && e.state.view){
 				self.setView(e.state.view, false);
 			}
 		});

 		$(window).on("markerclicked", function(jqEvent, e){
 			if(e){
 				self.selectMarker(e);
 				self.map.options.touched = true;
 				self.map.setCenter(e.listing.location.coordinates[0], e.listing.location.coordinates[1]);
 			}
 		});

		// View toggle
		jQuery('.find-location .views [data-value]').on('click', function(){
			var view = $(this).attr('data-value');
			self.setView(view, true);
		});

		// Determine display state, view, geographic biasing query
		var query = frc.utilities.getUrlParameter("query");
		var view = frc.utilities.getUrlParameter("view");
		var geo = null;
		var temp = frc.utilities.getUrlParameter("coords").split(",");
		if(temp.length===2){
			if(!isNaN(window.parseFloat(temp[0])) && !isNaN(window.parseFloat(temp[1]))){
				geo = [ window.parseFloat(temp[0]), window.parseFloat(temp[1]) ];
			}
		}

		if(geo||query){

			self.data.displayState = "biased";
			self.data.biasing.type = "geographic";

			if(geo){
				// Coordinates provided via geolocation
				self.data.biasing.method = "geo";
				self.data.biasing.value.coords = geo;
			} else if(query){
				// Query provided
				self.data.biasing.method = "query";
				self.data.biasing.value.raw = query;
			}
		}

		// Set the correct display state of the page. This does not change.
		self.setDisplayState(self.data.displayState);

		// Set the correct view
		self.setView(view, false);
 	},
 	"selectMarker": function(markerInfo){
		frc.utilities.handlebars.populate("locations-map-result-listing", markerInfo.listing, ".locations-map-result-listing-wrapper", false);

		// Reset markers
		frc.page.data.mapMarkers.forEach(function(item){
			item.marker.setIcon(item.originalIcon);
			item.marker.setZIndex(0);
		});

		var icon = frcContext.brand.images.mapMarkers.normalSelected || '/static-demo/images/icons/map-marker-big.png';
		if(markerInfo.listing.location.statusIndicationMessage=="coming_soon"){
			icon = frcContext.brand.images.mapMarkers.comingSoonSelected || '/static-demo/images/icons/map-marker-big-soon.png';
		}

		//self.map.setCenter(markerInfo.listing.location.coordinates[0], markerInfo.listing.location.coordinates[1]);
		markerInfo.marker.setIcon(icon);
		markerInfo.marker.setZIndex(1);
 	},
 	"getData": function(){
 		var self = frc.pages.locations;
		frc.api.brand.getLocations(function(response){
			if(response && response.data && response.data.length){
				if(self.data.displayState=="biased"){
					// Calculate distances and sort if geographically biasing
					if(self.data.biasing.type=="geographic" && self.data.biasing.value.coords){
						self.data.listings = [];
						var coords = self.data.biasing.value.coords;
						response.data.forEach(function(listing){
							if (listing.location.coordinates) {
								listing.distanceMiles = frc.utilities.getDistance(coords[0], coords[1], listing.location.coordinates[0], listing.location.coordinates[1]);
								if(Math.round(listing.distanceMiles) !== 1){
									if(!Math.floor(listing.distanceMiles)){
										listing.distanceFriendly = "Less than a mile";
									} else {
										listing.distanceFriendly = Math.round(listing.distanceMiles).toLocaleString() + " miles";
									}
								} else {
									listing.distanceFriendly = "1 mile";
								}
								self.data.listings.push(listing);
							}
						});
						self.data.listings = self.data.listings.sort(function(a, b){
							return a.distanceMiles - b.distanceMiles;
						});

						// Return only one location if none within max distance
						if(self.data.listings[0].distanceMiles>self.config.maxDistanceMiles){
							self.data.listings = [self.data.listings[0]];
						}
					}

				} else if(self.data.displayState=="initial") {
					// No need to calculate distances; use data as-is
					self.data.listings = response.data;
				}

				// Data is ready; we'll trigger our event and subsequently render the data, if needed
				$(self).trigger('dataready');
			}
		});
 	},
 	"setDisplayState": function(value){
 		jQuery('body').attr('data-display-state', value);
 	},
 	"setView": function(value, pushState){
 		var self = frc.pages.locations;
 		if(value=="map"||value=="list"){
 			self.data.view = value;
 		}
 		jQuery('body').attr('data-view', self.data.view);

 		// History API
 		if(pushState && window.history){
 			window.history.pushState({
 				"view": value
 			}, document.title, self.getHistoryAPILink());
 		}

 		$(self).trigger('viewchanged');
 	},
 	"renderMap": function(){
 		var self = frc.pages.locations;
 		self.data.mapInited = true;

 		if(self.data.listings && self.data.listings.length) {
		   self.map = new frcMap({
		    	autocenter: true,
		        container: 'locations-map-results', // ID of div where map will be output - Default is 'locations-map-canvas'.
		        center: [39.7192109,-104.9556118], // Array containing latitude and longitude for central point of map. Default is [38.973731, -109.210078].
		        listings: self.data.listings
		    });
 		}
 	},
 	"populateBiasedView": function(listings){
 		var self = frc.pages.locations;
 		if(self.data.biasing.type=="geographic"){
 			// self.populateResultsMessage();
	 		frc.utilities.handlebars.populate("locations-geographic-biasing", {
	 			"listings": listings,
	 			"config": self.config,
	 			"biasing": self.data.biasing,
	 			"nearbyLocationsExist": self.data.listings && self.data.listings.length && self.data.listings[0].distanceMiles <= self.config.maxDistanceMiles,
	 			"viewAllLink": self.getViewAllLink()
	 		}, ".display-states [data-display-state=\"biased\"]", false);
 		}

		$(window).trigger('listing-loaded');
 	},
 	"populateResultsMessage": function(){
 		var self = frc.pages.locations;
 		if (self.data.biasing.type) {
	 		jQuery('.listing-message').each(function(i, elt){
	 			$(this).removeClass("active").html("");
	 			var version = $(elt).parents(".location-search").length?"abridged":"full";
	 			if(!(version=="abridged" && self.data.view=="list")){
	 				// If it's the list view, don't show the results messaging in the location search area
			 		frc.utilities.handlebars.populate("locations-results-message", {
			 			"version": version,
			 			"numListings": self.data.listings?self.data.listings.length:0,
			 			"config": self.config,
			 			"displayState": self.data.displayState,
			 			"biasing": self.data.biasing,
			 			"view": self.data.view,
			 			"nearbyLocationsExist": self.data.listings && self.data.listings.length && self.data.listings[0].distanceMiles <= self.config.maxDistanceMiles
			 		}, $(elt), false);
			 		$(elt).addClass("active");
	 			} else {
	 				$(elt).removeClass("active").html("");
	 			}
	 		});
	 	}
 	},
 	"getHistoryAPILink": function(){
 		var self = frc.pages.locations;
 		var url = "./?";
 		var params = {};
 		if(self.data.displayState=="biased"){
 			if(self.data.biasing.type=="geographic"){
 				if(self.data.biasing.method=="query"){
 					params["query"] = self.data.biasing.value.raw;
 				} else if(self.data.biasing.method=="geo"){
 					params["coords"] = self.data.biasing.value.coords.join(",");
 				}
 			}
 		}
 		if(self.data.view!="list"){
 			params["view"] = self.data.view;
 		}
 		return url + jQuery.param(params);
 	},
 	"getViewAllLink": function(){
 		var self = frc.pages.locations;
 		self.data.viewAllLink = (self.data.view=="map")?"./?view=map":"./";
 		return self.data.viewAllLink;
 	},
 	"pinNavigation": function(){
 		$('.listing-state-nav').pinUp({
            class: 'pinned',
            container: 'section.block-list .wrapper',
            offset: {
                element: '#nav-bumper'
            },
            watchHandlers: [{
                object: frc.pages.locations,
                event: 'viewchanged'
            },
            {
                object: $(window),
                event: 'navBumper'
            }]
        });
 	}
};